// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-container{\n    display: flex;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    padding: 4px;\n    border-radius: 4px;\n    background-color: var(--royal-blue-100);\n}", ""]);
// Exports
module.exports = exports;
